<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
        >
          <product-group />
        </b-col>
        <b-col
          cols="12"
        >
          <title-text />
        </b-col>
        <b-col
          cols="12"
        >
          <content-text />
        </b-col>

        <b-col
          cols="12"
          md="6"
        >
          <product-ordering />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <product-status />
        </b-col>
      </b-row>
    </b-card>
    <b-row>
      <b-col
        cols="12"
      >
        <image-card />
      </b-col>
      <b-col
        cols="12"
      >
        <image-card-header />
      </b-col>
      <b-col
        cols="12"
      >
        <photo-gallery />
      </b-col>
    </b-row>
    <b-button
      variant="primary"
      :disabled="itemData.submitStatus"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </div>
</template>

<script>
/*
image
status
 */
import {
  BCard, BCol, BRow, BButton,
} from 'bootstrap-vue'
import { required } from '@validations'
import ProductGroup from '@/views/Admin/Product_groups/elements/ProductGroup.vue'
import TitleText from '@/views/Admin/Product_groups/elements/TitleText.vue'
import ContentText from '@/views/Admin/Product_groups/elements/ContentText.vue'
import ProductOrdering from '@/views/Admin/Product_groups/elements/ProductOrdering.vue'
import ProductStatus from '@/views/Admin/Product_groups/elements/ProductStatus.vue'
import ImageCard from '@/views/Admin/Product_groups/elements/ImageCard.vue'
import PhotoGallery from "@/views/Admin/Product_groups/elements/PhotoGallery.vue";
import ImageCardHeader from "@/views/Admin/Product_groups/elements/ImageCardHeader.vue";

export default {
  name: 'ItemForm',
  components: {
    ImageCardHeader,
    PhotoGallery,
    BCard,
    BRow,
    BCol,
    BButton,
    ProductGroup,
    TitleText,
    ContentText,
    ProductOrdering,
    ProductStatus,
    ImageCard,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      required,
      imageUrl: this.$store.state.app.baseURL,
      snowOption: {
        theme: 'snow',
      },
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['productGroups/dataItem']
    },
  },
  created() {
    this.getProductGroups()
  },
  methods: {
    getProductGroups() {
      this.$store.dispatch('productGroups/getDataList', {
        select: [
          'product_categories.id AS id',
          'product_categories.title AS title',
        ],
        where: {
          'product_categories.id_product_categories': null,
        },
      })
    },
  },
}
</script>
